import cloneDeep from 'lodash.clonedeep';
import { MultiLevelPricing } from '@seatsio/seatsio-types';
import { Discounts, Selections } from './types';

export function pricingMagic(
  showPromoCodes: boolean = false,
  discounts: Discounts = [],
  ticketsMaxQtys: Record<string, number>,
  selections: Selections = [],
): MultiLevelPricing[] {
  if (!window.seatsioSeatingCharVars || !window.seatsioSeatingCharVars.pricing) {
    console.warn('No pricing configuration found in window.seatsioSeatingCharVars');
    return [];
  }
  const pricing = cloneDeep(window.seatsioSeatingCharVars.pricing);
  const selectedTicketCounts: Record<string, number> = {};
  selections.forEach(selection => {
    const baseTicketType = selection.ticketType.split('-')[0];
    selectedTicketCounts[baseTicketType] = (selectedTicketCounts[baseTicketType] || 0) + 1;
  });
  pricing.forEach(category => {
    category.ticketTypes = category.ticketTypes
      .filter(ticketType => ticketType.ticketType.endsWith('-p') === showPromoCodes)
      .filter(ticketType => {
        // Filter out ticket types that have reached their maximum quantity
        const baseTicketType = ticketType.ticketType.split('-')[0];
        const maxQty = ticketsMaxQtys[baseTicketType] || 0;
        const selectedCount = selectedTicketCounts[baseTicketType] || 0;
        return maxQty === 0 || selectedCount < maxQty;
      })
      .map(ticketType => {
        const discount = discounts.find(d => `${d.ticket}-p` === ticketType.ticketType);
        if (discount) {
          return {
            ...ticketType,
            price: discount.newPrice,
            originalPrice: ticketType.price,
          };
        }
        return {
          ...ticketType,
        };
      });
  });
  return pricing.filter(category => category.ticketTypes.length > 0);
}
